import { render } from "./ProductCodeSuggestCombobox.vue?vue&type=template&id=0b8adf41"
import script from "./ProductCodeSuggestCombobox.vue?vue&type=script&lang=js"
export * from "./ProductCodeSuggestCombobox.vue?vue&type=script&lang=js"

import "./ProductCodeSuggestCombobox.vue?vue&type=style&index=0&id=0b8adf41&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__